import React, { useState } from "react";
import "./recommended.scss";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
const icon_right = require("../../../assets/images/icons/Icon-right.svg");
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

const Recommended = (props: ReferenciaContenido) => {
  const recommendedData = props;

  const [isTopExpanded, setTopExpanded] = useState(true);
  const [isMidExpanded, setMidExpanded] = useState(true);
  const hasDescription = () => {
    return recommendedData.referenciaPlantillaContenido[0].descripcion !=
      undefined
      ? true
      : false;
  };

  const togleExpansion = (card) => {
    if (card == "mid") {
      setMidExpanded(true);
      setTopExpanded(false);
    }
    if (card == "top") {
      setTopExpanded(true);
      setMidExpanded(true);
    }

    if (card == "bot") {
      setTopExpanded(false);
      setMidExpanded(false);
    }
  };

  const setGmt = (title) => {
    if (props.nombreCategoria === "Home") {
      return `gtmRedDeAmorSesionIniciadaRecomendadosParaTi${normalizeTwoWords(
        title
      )}`;
    } else if (props.nombreCategoria === "Biblioteca") {
      return `gtmRedDeAmorCarrusel${normalizeTwoWords(title)}`;
    } else {
      return `gtmRedDeAmor${normalizeTwoWords(
        props.nombreCategoria
      )}${normalizeTwoWords(title)}`;
    }
  };
  return (
    <div
      className={`m-recommended ${
        recommendedData?.nombreCategoria === "Interna empresas"
          ? "enterprises"
          : ""
      }  ${
        recommendedData?.nombreCategoria === "Biblioteca" ||
        recommendedData?.nombreCategoria === "Home"
          ? "margin-t"
          : "margin-n"
      } `}
    >
      <div className="center">
        <div
          className={`m-recommended__title ${
            recommendedData?.nombreCategoria === "Interna empresas"
              ? "enterprises"
              : ""
          } `}
        >
          <h2>{recommendedData?.tituloGeneral}</h2>
        </div>
      </div>

      {hasDescription() ? (
        <div className="m-recommended-desktop-desc hide-on-mobile">
          <div className="m-recommended-desktop-desc__col">
            <div className="m-recommended-desktop-desc__col__img">
              <img
                src={
                  recommendedData?.referenciaPlantillaContenido[0]
                    ?.imagenPrincipal[0]?.file.url
                }
                alt={
                  recommendedData?.referenciaPlantillaContenido[0]
                    ?.imagenPrincipal[0]?.title
                }
              />
              <div className="gradient"></div>
            </div>

            <h3
              className={`${setGmt(
                recommendedData?.referenciaPlantillaContenido[0]?.tituloBanner
              )}`}
            >
              {recommendedData?.referenciaPlantillaContenido[0]?.tituloBanner}
            </h3>
            <p>
              {
                JSON.parse(
                  recommendedData?.referenciaPlantillaContenido[0]?.descripcion
                    ?.raw
                )?.content?.[0]?.content[0]?.value
              }
            </p>
            <a
              className={`m-recommended-desktop-desc__col__link ${setGmt(
                recommendedData?.referenciaPlantillaContenido[0]?.tituloBanner
              )}`}
              href={
                recommendedData?.referenciaPlantillaContenido[0]
                  ?.redireccionBoton
              }
              target="_blank"
              rel="noreferrer"
            ></a>
          </div>
          <div className="m-recommended-desktop-desc__col">
            <div className="m-recommended-desktop-desc__col__img">
              <img
                src={
                  recommendedData?.referenciaPlantillaContenido[1]
                    ?.imagenPrincipal[0]?.file.url
                }
                alt={
                  recommendedData?.referenciaPlantillaContenido[1]
                    ?.imagenPrincipal[0]?.title
                }
              />
              <div className="gradient"></div>
            </div>
            <h3
              className={`${setGmt(
                recommendedData?.referenciaPlantillaContenido[1]?.tituloBanner
              )}`}
            >
              {recommendedData?.referenciaPlantillaContenido[1]?.tituloBanner}
            </h3>
            <p>
              {
                JSON.parse(
                  recommendedData?.referenciaPlantillaContenido[1]?.descripcion
                    ?.raw
                ).content[0].content[0].value
              }
            </p>
            <a
              className={`m-recommended-desktop-desc__col__link ${setGmt(
                recommendedData?.referenciaPlantillaContenido[1]?.tituloBanner
              )}`}
              href={
                recommendedData?.referenciaPlantillaContenido[1]
                  ?.redireccionBoton
              }
              target="_blank"
              rel="noreferrer"
            ></a>
          </div>
          <div className="m-recommended-desktop-desc__col">
            <div className="m-recommended-desktop-desc__col__img">
              <img
                src={
                  recommendedData.referenciaPlantillaContenido[2]
                    ?.imagenPrincipal[0]?.file.url
                }
                alt={
                  recommendedData?.referenciaPlantillaContenido[2]
                    ?.imagenPrincipal[0]?.title
                }
              />
              <div className="gradient"></div>
            </div>
            <h3
              className={`${setGmt(
                recommendedData?.referenciaPlantillaContenido[2]?.tituloBanner
              )}`}
            >
              {recommendedData?.referenciaPlantillaContenido[2]?.tituloBanner}
            </h3>
            <p>
              {
                JSON.parse(
                  recommendedData?.referenciaPlantillaContenido[2]?.descripcion
                    ?.raw
                )?.content[0].content[0].value
              }
            </p>
            <a
              className={`m-recommended-desktop-desc__col__link ${setGmt(
                recommendedData?.referenciaPlantillaContenido[2]?.tituloBanner
              )}`}
              href={
                recommendedData?.referenciaPlantillaContenido[2]
                  ?.redireccionBoton
              }
              target="_blank"
              rel="noreferrer"
            ></a>
          </div>
        </div>
      ) : (
        <div className="m-recommended-desktop hide-on-mobile">
          <div className="m-recommended-desktop__col">
            <img
              src={
                recommendedData?.referenciaPlantillaContenido[0]
                  ?.imagenPrincipal[0]?.file.url
              }
              alt={
                recommendedData?.referenciaPlantillaContenido[0]
                  ?.imagenPrincipal[0]?.title
              }
            />
            <a
              className={`${setGmt(
                recommendedData?.referenciaPlantillaContenido[0]?.tituloBanner
              )}`}
              href={
                recommendedData?.referenciaPlantillaContenido[0]
                  ?.redireccionBoton
              }
              target="_blank"
              rel="noreferrer"
            >
              <div className="gradient"></div>
            </a>
            <a
              className={`${setGmt(
                recommendedData?.referenciaPlantillaContenido[0]?.tituloBanner
              )}`}
              href={
                recommendedData?.referenciaPlantillaContenido[0]
                  ?.redireccionBoton
              }
              target="_blank"
              rel="noreferrer"
            >
              <h3
                className={`${setGmt(
                  recommendedData?.referenciaPlantillaContenido[0]?.tituloBanner
                )}`}
              >
                {recommendedData?.referenciaPlantillaContenido[0]?.tituloBanner}
              </h3>
            </a>
          </div>
          <div className="m-recommended-desktop__col">
            <img
              src={
                recommendedData?.referenciaPlantillaContenido[1]
                  ?.imagenPrincipal[0]?.file.url
              }
              alt={
                recommendedData?.referenciaPlantillaContenido[1]
                  ?.imagenPrincipal[0]?.title
              }
            />
            <a
              className={`${setGmt(
                recommendedData?.referenciaPlantillaContenido[1]?.tituloBanner
              )}`}
              href={
                recommendedData?.referenciaPlantillaContenido[1]
                  ?.redireccionBoton
              }
              target="_blank"
              rel="noreferrer"
            >
              <div className="gradient"></div>
            </a>
            <a
              className={`${setGmt(
                recommendedData?.referenciaPlantillaContenido[1]?.tituloBanner
              )}`}
              href={
                recommendedData?.referenciaPlantillaContenido[1]
                  ?.redireccionBoton
              }
              target="_blank"
              rel="noreferrer"
            >
              <h3
                className={`${setGmt(
                  recommendedData?.referenciaPlantillaContenido[1]?.tituloBanner
                )}`}
              >
                {recommendedData?.referenciaPlantillaContenido[1]?.tituloBanner}
              </h3>
            </a>
          </div>
          <div className="m-recommended-desktop__col">
            <img
              src={
                recommendedData?.referenciaPlantillaContenido[2]
                  ?.imagenPrincipal[0]?.file.url
              }
              alt={
                recommendedData?.referenciaPlantillaContenido[2]
                  ?.imagenPrincipal[0]?.title
              }
            />
            <a
              className={`${setGmt(
                recommendedData?.referenciaPlantillaContenido[2]?.tituloBanner
              )}`}
              href={
                recommendedData?.referenciaPlantillaContenido[2]
                  ?.redireccionBoton
              }
              target="_blank"
              rel="noreferrer"
            >
              <div className="gradient"></div>
            </a>
            <a
              className={`${setGmt(
                recommendedData?.referenciaPlantillaContenido[2]?.tituloBanner
              )}`}
              href={
                recommendedData?.referenciaPlantillaContenido[2]
                  ?.redireccionBoton
              }
              target="_blank"
              rel="noreferrer"
            >
              <h3
                className={`${setGmt(
                  recommendedData?.referenciaPlantillaContenido[2]?.tituloBanner
                )}`}
              >
                {recommendedData?.referenciaPlantillaContenido[2]?.tituloBanner}
              </h3>
            </a>
          </div>
        </div>
      )}

      <div className="m-recommended-mobile show-on-mobile">
        <div className="center">
          <div className="m-recommended-mobile__container">
            <div
              className={`m-recommended-mobile__container__card ${
                isTopExpanded ? "expanded" : ""
              }`}
              onClick={() => {
                togleExpansion("top");
              }}
            >
              <img
                src={
                  recommendedData?.referenciaPlantillaContenido[0]
                    ?.imagenPrincipal[0]?.file.url
                }
                alt={
                  recommendedData?.referenciaPlantillaContenido[0]
                    ?.imagenPrincipal[0]?.title
                }
              />
              <div className="gradient"></div>
              <h3 className={`${isTopExpanded ? "expanded" : ""}`}>
                {recommendedData?.referenciaPlantillaContenido[0]?.tituloBanner}
              </h3>
              <div
                className={`m-recommended-mobile__container__card__btn ${
                  isTopExpanded ? "expanded" : "hidden"
                }`}
              >
                <a
                  href={
                    recommendedData?.referenciaPlantillaContenido[0]
                      ?.redireccionBoton
                  }
                  target="_blank"
                  rel="noreferrer"
                  className={`m-recommended-mobile__container__card__btn__arrow ${setGmt(
                    recommendedData?.referenciaPlantillaContenido[0]
                      ?.tituloBanner
                  )}`}
                >
                  <p>SABER MÁS</p>
                  <div>
                    <img src={icon_right} alt="icon-right" />
                  </div>
                </a>
              </div>
            </div>
            <div
              className={`m-recommended-mobile__container__card ${
                isMidExpanded ? "expanded" : ""
              }`}
              onClick={() => {
                togleExpansion("mid");
              }}
            >
              <img
                src={
                  recommendedData?.referenciaPlantillaContenido[1]
                    ?.imagenPrincipal[0]?.file.url
                }
                alt={
                  recommendedData?.referenciaPlantillaContenido[1]
                    ?.imagenPrincipal[0]?.title
                }
              />
              <div className="gradient"></div>
              <h3
                className={`${
                  !isTopExpanded && isMidExpanded ? "expanded" : ""
                }`}
              >
                {recommendedData?.referenciaPlantillaContenido[1]?.tituloBanner}
              </h3>
              <div
                className={`m-recommended-mobile__container__card__btn ${
                  !isTopExpanded && isMidExpanded ? "expanded" : "hidden"
                }`}
              >
                <a
                  className={`m-recommended-mobile__container__card__btn__arrow ${setGmt(
                    recommendedData?.referenciaPlantillaContenido[1]
                      ?.tituloBanner
                  )}`}
                  href={
                    recommendedData?.referenciaPlantillaContenido[1]
                      ?.redireccionBoton
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  <p>SABER MÁS</p>
                  <div>
                    <img src={icon_right} alt="icon-right" />
                  </div>
                </a>
              </div>
            </div>
            <div
              className="m-recommended-mobile__container__card"
              onClick={() => {
                togleExpansion("bot");
              }}
            >
              <img
                src={
                  recommendedData?.referenciaPlantillaContenido[2]
                    ?.imagenPrincipal[0]?.file.url
                }
                alt={
                  recommendedData?.referenciaPlantillaContenido[2]
                    ?.imagenPrincipal[0]?.title
                }
              />
              <div className="gradient"></div>
              <h3
                className={`${
                  !isTopExpanded && !isMidExpanded ? "expanded" : ""
                }`}
              >
                {recommendedData?.referenciaPlantillaContenido[2]?.tituloBanner}
              </h3>
              <div
                className={`m-recommended-mobile__container__card__btn ${
                  !isTopExpanded && !isMidExpanded ? "expanded" : "hidden"
                }`}
              >
                <a
                  className={`m-recommended-mobile__container__card__btn__arrow ${setGmt(
                    recommendedData?.referenciaPlantillaContenido[2]
                      ?.tituloBanner
                  )}`}
                  href={
                    recommendedData?.referenciaPlantillaContenido[2]
                      ?.redireccionBoton
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  <p>SABER MÁS</p>
                  <div>
                    <img src={icon_right} alt="icon-right" />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Recommended;
